/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentDetailAliases {
  BREADCRUMB_0 = 'breadcrumb-0',
  FRAGMENT_0 = 'fragment-0',
  LAYOUT_DETAILS = 'layout-details',
  PANEL_0 = 'panel-0',
}
export { AppointmentDetailAliases };
